import { useMemo } from 'react';
import { useToken } from '@chakra-ui/react';
import type { CustomIconProps } from '../types';

const Share = ({
    width,
    height,
    color = 'currentColor',
    dataTestId,
    ...props
}: CustomIconProps): JSX.Element => {
    const [tokenColor] = useToken('colors', [color], [color]);
    const resolvedColor = useMemo(() => tokenColor, [tokenColor]);

    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={width ?? '15'}
            height={height ?? '16'}
            viewBox="0 0 15 16"
            fill={resolvedColor}
            data-testid={dataTestId}
            {...props}
        >
            <path d="M11.6924 0C13.2556 0 14.5231 1.267 14.5234 2.83008C14.5234 4.39347 13.2558 5.66113 11.6924 5.66113C10.8719 5.66101 10.1351 5.30973 9.61816 4.75195L5.52734 7.13965C5.61382 7.41097 5.66111 7.70001 5.66113 8C5.66111 8.29974 5.61368 8.58826 5.52734 8.85938L9.62109 11.2451C10.1379 10.689 10.8733 10.339 11.6924 10.3389C13.2557 10.3389 14.5232 11.6057 14.5234 13.1689C14.5234 14.7323 13.2558 16 11.6924 16C10.1291 15.9998 8.8623 14.7322 8.8623 13.1689C8.86234 12.8675 8.90973 12.5772 8.99707 12.3047L4.9043 9.9209C4.3874 10.4785 3.65147 10.83 2.83105 10.8301C1.26777 10.8299 0.000108113 9.56322 0 8C0.000129834 6.4368 1.26778 5.16908 2.83105 5.16895C3.65128 5.16906 4.38741 5.52065 4.9043 6.07812L8.99609 3.69043C8.90965 3.41916 8.8623 3.13002 8.8623 2.83008C8.86268 1.26715 10.1293 0.000238468 11.6924 0ZM11.6924 11.5693C11.1239 11.5695 10.6255 11.8666 10.3418 12.3135C10.3341 12.33 10.3287 12.3482 10.3193 12.3643C10.3083 12.3832 10.2929 12.3987 10.2803 12.416C10.1604 12.6403 10.0928 12.8968 10.0928 13.1689C10.0928 14.0525 10.8089 14.7683 11.6924 14.7686C12.5761 14.7686 13.292 14.0526 13.292 13.1689C13.2918 12.2855 12.576 11.5693 11.6924 11.5693ZM2.83105 6.40039C1.94755 6.40052 1.2306 7.11653 1.23047 8C1.23058 8.88348 1.94753 9.59948 2.83105 9.59961C3.71451 9.5994 4.43056 8.88343 4.43066 8C4.43053 7.11658 3.71449 6.4006 2.83105 6.40039ZM11.6924 1.23047C10.8091 1.23071 10.0931 1.94689 10.0928 2.83008C10.0928 3.71359 10.8089 4.43043 11.6924 4.43066C12.5761 4.43066 13.292 3.71373 13.292 2.83008C13.2916 1.94674 12.5759 1.23047 11.6924 1.23047Z" />
        </svg>
    );
};

export default Share;
